/**
 * Enum for item status.
 *
 * @readonly
 * @enum string
 */
const STATUS = Object.freeze({
  ADDED: 'ADDED',
  QUEUED: 'QUEUED',
  UPLOADING: 'UPLOADING',
  ERROR: 'ERROR',
  DONE: 'DONE',
})

export default STATUS
